import { PlusIcon } from "@heroicons/react/24/outline";
import type { ProjectsHeaderProps } from "./projectsHeader.types";

export function ProjectsHeader({ onCreateProject }: ProjectsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-raro-gray-900 font-montserrat">
          Meus Projetos
        </h1>
        <p className="text-raro-gray-600 mt-1">
          Gerencie e acompanhe o desenvolvimento dos seus projetos
        </p>
      </div>

      <button
        onClick={onCreateProject}
        className="inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold font-montserrat rounded-xl transition-all duration-200 shadow-raro hover:shadow-raro-lg"
      >
        <PlusIcon className="w-5 h-5 mr-2" />
        Novo Projeto
      </button>
    </div>
  );
}